import React, { useEffect, useRef, useState } from 'react';
import classes from "./EditProfile.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaTrash, FaUpload } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import { getProfile, updateProfile } from '../http/http';
import { toast } from "react-toastify";
import MediumLoader from '../components/Loaders/MediumLoader';
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';


const EditProfile = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const dispatch=useDispatch();

    const { t } = useTranslation();

    const [state, setState] = useState({
        name: "",
        image: "",
    });

    const [pickedImage, setPickedImage] = useState();
    const imageInput = useRef();

    function handlePickClick() {
        imageInput.current.click();
    }

    function handleImageChange(event) {
        const file = event.target.files[0];

        if (!file) {
            setPickedImage(null);
            return;
        }

        const fileReader = new FileReader();

        fileReader.onload = () => {
            setPickedImage(fileReader.result);
            // setState(prevState => ({ ...prevState, image: fileReader.result }));
        };

        fileReader.readAsDataURL(file);
        setState(prevState => ({ ...prevState, image: file }));
    }

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfile(userToken);
            setProfile(response?.data?.result);
            setState((prevValue) => ({ ...prevValue, name: response?.data?.result?.name || "Guest" }));
            setLoading(false);
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }


    useEffect(() => {
        if (userToken) {
            fetchUserProfile();
        }
    }, [userToken]);

    const submitHandler = async (e) => {
        try {
            e.preventDefault();
            setSaveLoading(true);

            const formData = new FormData();
            formData.append("name", state?.name);
            if (state?.image) {
                formData.append("file", state?.image ?? null);
            }

            const result = await updateProfile(formData, userToken);
            setSaveLoading(false);
            toast.success("Profile update has been completed successfully.")
            navigate("/home");
        } catch (error) {
            toast.error("Something Went Wrong!");
        }
    }

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("20")}</h2>
                </div>

                {loading ? <MediumLoader /> : (
                    <form onSubmit={submitHandler} className={classes.form} enctype="multipart/form-data">
                        <div className={classes.edit_avatar_section}>
                            <div className={classes.avatar_image_container}>
                                <img src={profile?.image || "/assets/images/dummy.png"} alt="profile pic" className={classes.avatar_image} />
                                <span className={classes.badge}>
                                    <FaTrash className={classes.trash_icon} />
                                </span>
                            </div>

                            <div>
                                <input
                                    className={classes.input}
                                    type="file"
                                    id="image"
                                    accept="image/png, image/jpeg"
                                    name="file"
                                    ref={imageInput}
                                    onChange={handleImageChange}
                                />
                                <button
                                    className={classes.button}
                                    type="button"
                                    onClick={handlePickClick}
                                >
                                    <FaUpload className={classes.upload_icon} />
                                    {t("27")}
                                </button>
                            </div>

                        </div>

                        {pickedImage && (
                            <div className={classes.selected_image_container}>
                                <img
                                    src={pickedImage}
                                    alt="The image selected by the user."
                                    className={classes.selected_image}
                                />
                            </div>
                        )}

                        <div className={classes.user_details_container}>
                            <p className={classes.user_name}>{t("28")} </p>
                            <input type='text' className={classes.user_name_input} name='name' placeholder={t("349")} value={state.name} onChange={(event) => setState({ ...state, name: event.target.value })} />
                            <button className={classes.save_changes_btn} type='submit' >
                                {saveLoading ? t("31") : t("30")}
                            </button>
                        </div>
                    </form>
                )}



            </div>
            <BottomNavbar active={4} />
        </>
    )
}

export default EditProfile